import clsx from "clsx";

import { QuestionButtonProps } from "../../widget.types";

export function QuestionButton({
  isSelected,
  isCorrect,
  isSms,
  isCpl,
  isReminder,
  isDisabled,
  onClick,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & QuestionButtonProps) {
  return (
    <div className="quiz__buttons__button-container" {...props}>
      <button
        className={clsx(
          "quiz__buttons__button",
          isSelected && isCorrect && "quiz__buttons__button--correct",
          isSelected && !isCorrect && "quiz__buttons__button--incorrect",
          isDisabled && "quiz__buttons__button--disabled"
        )}
        data-testid="quiz-question-option-title"
        onClick={onClick}
      >
        {children}
      </button>
    </div>
  );
}
